import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import {
  Sgke383aRequest,
  Sgke383aResponse,
  Sgke383aService
} from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke383aService {

  /**
   * コンストラクタ
   * @param {Sgke383aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke383aService
   */
  constructor(
    public service: Sgke383aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * SGKE383A_サービサー委託対象登録API呼出し
   * @param {Sgke383aRequest} request 
   * @returns {*}  {Observable<Sgke383aResponse>}
   * @memberof UsedSgke383aService
   */
  public doSgke383a(request: Sgke383aRequest): Observable<Sgke383aResponse> {

    return this.service.sgke383aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),

        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE383A');
          return throwError(err.message);
        })
      );
  }

}
